import React from 'react'
import { createPortal } from 'react-dom'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import styles from './index.module.css'
import cx from 'clsx'
const Tooltip: React.FC<React.ComponentProps<typeof ReactTooltip>> = ({
  children,
  className,
  variant = 'dark',
  classNameArrow = 'text-slate-950',
  delayShow = 333,
  id,
  ...props
}) => {
  const portalContainer = document.getElementById('popup-container')

  const tooltip = (
    <ReactTooltip
      delayShow={delayShow}
      id={id}
      classNameArrow={classNameArrow}
      variant={variant}
      className={cx(styles.tooltip, className)}
      {...props}
    >
      {children}
    </ReactTooltip>
  )

  if (portalContainer) {
    return createPortal(tooltip, portalContainer)
  }

  return tooltip
}

export default Tooltip
